import { Link } from '@inertiajs/react';
import { ReactNode } from 'react';
import { ChevronRight } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { Icon } from '../../Shared/UI/Icon';
import { useRouter } from '../router';
import Container from '../UI/Container';
import Header from '../UI/Header';

export function EmbedHeader({
  children,
}: {
  children?: ReactNode;
}) {
  const { t } = useTranslation();
  const { routes } = useRouter();

  return (
    <Header>
      <Container className="pt-8">
        <div className="mb-2 text-sm text-slate-500">
          <Link href={routes.embeds_page()} className="mr-2">
            {t('backend:embeds')}
          </Link>
          <Icon>
            <ChevronRight />
          </Icon>
        </div>

        <div>
          {children}
        </div>
      </Container>
    </Header>
  );
}
